// How long a user may be kept waiting on a blocking call before being told.
export const USER_WAIT_DEADLINE_MS = 10000;
